import React, { useEffect, useState } from "react";
import { api, errorMessage } from "../../lib/api";
import { Card } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { Badge } from "../../components/ui/badge";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../../components/ui/select";
import { fmtDate } from "../../lib/constants";
import { toast } from "sonner";

const STATUS_CLASS = {
  active: "bg-emerald-500/10 text-emerald-300 border-emerald-500/20",
  pending: "bg-amber-500/10 text-amber-300 border-amber-500/20",
  suspended: "bg-rose-500/10 text-rose-300 border-rose-500/20",
};

export default function AdminBrokers() {
  const [brokers, setBrokers] = useState([]);

  const load = async () => {
    try {
      const { data } = await api.get("/admin/brokers");
      setBrokers(data);
    } catch (e) { toast.error(errorMessage(e)); }
  };
  useEffect(() => { load(); }, []);

  const change = async (id, status) => {
    try {
      await api.patch(`/admin/brokers/${id}/status`, { status });
      toast.success(`Broker marked ${status}`);
      load();
    } catch (e) { toast.error(errorMessage(e)); }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-semibold tracking-tight">Brokers</h1>
        <p className="mt-1 text-sm text-slate-400">Manage your marketing partners.</p>
      </div>
      <Card className="border-slate-800 bg-slate-900">
        <Table>
          <TableHeader>
            <TableRow className="border-slate-800 hover:bg-transparent">
              <TableHead className="text-slate-400">Name</TableHead>
              <TableHead className="text-slate-400">Email</TableHead>
              <TableHead className="text-slate-400">Status</TableHead>
              <TableHead className="text-slate-400">Training</TableHead>
              <TableHead className="text-slate-400">Apps</TableHead>
              <TableHead className="text-slate-400">Signup</TableHead>
              <TableHead className="text-slate-400 text-right">Change Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {brokers.map((b) => (
              <TableRow key={b.user_id} className="border-slate-800 hover:bg-slate-800/40" data-testid={`broker-row-${b.user_id}`}>
                <TableCell className="text-slate-100 font-medium">{b.name}</TableCell>
                <TableCell className="text-slate-300 text-sm">{b.email}</TableCell>
                <TableCell>
                  <Badge variant="outline" className={STATUS_CLASS[b.status] || ""}>{b.status || "active"}</Badge>
                </TableCell>
                <TableCell>
                  {b.training_completed ? (
                    <Badge variant="outline" className="bg-emerald-500/10 text-emerald-300 border-emerald-500/20">Certified</Badge>
                  ) : (
                    <Badge variant="outline" className="bg-amber-500/10 text-amber-300 border-amber-500/20">Pending</Badge>
                  )}
                </TableCell>
                <TableCell className="text-slate-300 tabular-nums">{b.application_count}</TableCell>
                <TableCell className="text-slate-400 text-sm">{fmtDate(b.created_at)}</TableCell>
                <TableCell className="text-right">
                  <Select value={b.status || "active"} onValueChange={(v) => change(b.user_id, v)}>
                    <SelectTrigger className="h-8 w-32 border-slate-800 bg-slate-950" data-testid={`broker-status-${b.user_id}`}>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent className="bg-slate-900 border-slate-800 text-slate-100">
                      <SelectItem value="active">Active</SelectItem>
                      <SelectItem value="pending">Pending</SelectItem>
                      <SelectItem value="suspended">Suspended</SelectItem>
                    </SelectContent>
                  </Select>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
